import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { useFpId } from '../hooks/useFpId';
import { queryKeys } from './queryKeys';
import { GoalTypeDTO } from '../types/goalsDTO';

export interface DecumulationDetailsDTO {
  GoalName: string;
  GoalType: GoalTypeDTO.Decumulation;
  GoalId: string;
  IsFunded: boolean;
  GoalResults: Record<string, string>;
  Beneficiaries: null;
  GoalOrigin: null;
  GoalDescription: null;
  IsCompleted: boolean;
}

interface FetcherParams {
  clientId: number;
  fpId: string;
}

const fetchDecumulationDetails = async ({
  clientId,
  fpId,
}: FetcherParams): Promise<DecumulationDetailsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/MC/DecumulationDetails', {
      clientId,
      fpId,
    }),
  );
};

export const useDecumulationDetailsQuery = () => {
  const clientId = useClientId();
  const fpId = useFpId();

  return useQuery(
    queryKeys.decumulationDetails(clientId, fpId),

    () => fetchDecumulationDetails({ clientId, fpId }),

    {
      cacheTime: 0,
    },
  );
};
